export const MOBILE_SEARCH_CONTROL_TITLE = "Packages";
export const MOBILE_SEARCH_CONTROL_TITLE_CORPORATE = "Hotels + flights";
export const MOBILE_SEARCH_CONTROL_MEGA_MENU_TITLE = "Explore";
export const MOBILE_SEARCH_CONTROL_CALENDAR_TITLE = "Choose dates";
